<template>
  <div class="input-group">
    <span class="input-group-btn">
        <button :class="buttonCssComputed"
                type="button"
                v-on:click="buttonRemove"
                :disabled="this.localQuantity <= min">
            <slot name="minus"><i class="lni lni-minus"></i></slot>
        </button>
    </span>
    <input type="text"
           class="form-control text-center"
           v-model.number="localQuantity"
           v-on:change="checkQuantity">
    <span class="input-group-btn">
      <button :class="buttonCssComputed"
              type="button"
              v-on:click="buttonAdd"
              :disabled="this.localQuantity >= max">
          <slot name="plus"><i class="lni lni-plus"></i></slot>
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AdvInputSpinner',
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number
    },
    buttonCss: {
      type: String
    },
    quantity: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      version: '0.0.3',
      localQuantity: this.quantity
    }
  },
  watch: {
    quantity (val) {
      this.localQuantity = val
    }
  },
  computed: {
    buttonCssComputed () {
      return this.buttonCss || 'btn btn-default btn-number'
    }
  },
  methods: {
    checkQuantity () {
      if (this.localQuantity < this.min) {
        this.localQuantity = this.min
      }

      if (this.localQuantity > this.max) {
        this.localQuantity = this.max
      }

      this.emitQuantity()
    },
    buttonRemove () {
      this.localQuantity -= 1
      this.checkQuantity()
    },
    buttonAdd () {
      this.localQuantity += 1
      this.checkQuantity()
    },
    emitQuantity () {
      this.$emit('quantity-changed', this.localQuantity)
    }
  }
}
</script>
